// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

import i18n from './routing-profile-group.properties';

const ROUTING_PROFILE_GROUP_VALUES = [
  'DRIVING',
  'DRIVING_HEAVY',
  'CYCLING',
  'FOOT',
  'WHEELCHAIR',
  'AIRBORNE'
] as const;

/** @see net/disy/cadenza/routing/param/RoutingProfileGroup.java */
export type RoutingProfileGroup = typeof ROUTING_PROFILE_GROUP_VALUES[number];

export const RoutingProfileGroup = {
  values: ROUTING_PROFILE_GROUP_VALUES as readonly RoutingProfileGroup[],
  i18n: (value: RoutingProfileGroup) => i18n(`<${value}>`)
} as const;

// </GENERATED-CODE>
